<div [style.min-height]="height()" [style.max-height]="height()">
    @if (state().close) {
        <div class="d-flex justify-content-between align-items-center pb-0">
            <div class="text-secondary font-xs">
                {{ state().title }}
            </div>
            <div>
                <button
                    type="button"
                    aria-label="Close"
                    class="btn-close text-reset btn-tiny"
                    (click)="closed.emit(true)"
                    [disabled]="!canClose()"
                ></button>
            </div>
        </div>
    }
    <div class="p-0">
        <voice-contacts-action
            #contactsaction
            (closeContacts)="closed.emit(true)"
        />
    </div>
    @if (!hidden()) {
        @if (showCallNumber()) {
            <div class="pb-3">
                <div class="input-group" [ngClass]="{ 'can-call': canCall() }">
                    <input
                        type="text"
                        class="form-control form-control-new weight-medium font-xl p-2 input-group-input"
                        placeholder="Type number"
                        aria-label="Type number"
                        (input)="onCallNumberChange($event)"
                        [value]="callNumber()"
                        maxlength="15"
                    />
                    <span class="input-group-text">
                        <button
                            type="button"
                            class="btn rounded-circle p-2"
                            [ngClass]="
                                canCall() ? 'btn-call' : 'btn-call-disabled'
                            "
                            (click)="loadActionComponentFromNumber()"
                        >
                            <i class="fa-lg fa-solid fa-phone"></i>
                        </button>
                    </span>
                </div>
            </div>
        }
        <div class="mb-3">
            <telxl-tab
                class="weight-medium font-md mb-3"
                [tabs]="filteredTabs()"
                [selected]="tabSelected"
                (selectedChange)="setSelected($event)"
                justifyContentClass="justify-content-end"
                tabPaddingY="0.3rem"
            />
        </div>
        <telxl-shared-contact-directory-panel
            [ngClass]="{
                'd-none': tabSelected !== 'contacts',
            }"
            [mode]="['emit']"
            [selected]="{ item: ['voice'], id: contactSelection }"
            [displayMediaIcons]="['Voice']"
            [showMediaFilter]="false"
            [requiresPhone]="true"
            [showDirectoryFilter]="true"
            [height]="contactsHeight()"
            [disabled]="disabled()"
            (clicked)="contactSelected($event)"
        />
        <telxl-shared-customer-directory-panel
            [ngClass]="{
                'd-none': tabSelected !== 'customers',
            }"
            [mode]="['emit']"
            [selected]="{ item: ['voice'], id: customerSelection }"
            [displayMediaIcons]="['Voice']"
            [showMediaFilter]="false"
            [showBusinessUnitFilter]="true"
            [showCreateCustomer]="false"
            [requiresPhone]="true"
            [disabled]="disabled()"
            [height]="contactsHeight()"
            (clicked)="customerSelected($event)"
        />
        <telxl-shared-agent-directory-panel
            [ngClass]="{
                'd-none': tabSelected !== 'agents',
            }"
            [agentId]="agent().id"
            [mode]="['emit']"
            [displayMediaIcons]="['Voice']"
            [selected]="{ item: ['voice'], id: agentSelection }"
            [height]="contactsHeight()"
            [restrictions]="['Idle']"
            [disabled]="disabled()"
            [useOperatorDialing]="true"
            (clicked)="agentSelected($event)"
        />
        <telxl-shared-internal-directory-panel
            [ngClass]="{
                'd-none': tabSelected !== 'internal',
            }"
            [mode]="['emit']"
            [displayMediaIcons]="['Voice']"
            [selected]="{ item: ['voice'], id: internalSelection }"
            [height]="contactsHeight()"
            [disabled]="disabled()"
            (clicked)="internalSelected($event)"
        />
        <telxl-shared-ivr-directory-panel
            [ngClass]="{
                'd-none': tabSelected !== 'ivr',
            }"
            [mode]="['emit']"
            [displayMediaIcons]="['Voice']"
            [selected]="{ item: ['voice'], id: ivrSelection }"
            [height]="contactsHeight()"
            [disabled]="disabled()"
            (clicked)="ivrSelected($event)"
        />
    }
</div>
